export default __webpack_public_path__ + "static/media/1.1607a5aa.jpg";